export const enForgotPassword = {
  //text
  SC50title: 'Password reset information',
  SC50title1: 'Reset password',
  SC50heading1: 'Please enter your registered email address.',
  SC50heading2: 'We will send you an email with the URL for resetting your password.',
  SC50submitReset: 'Send a reset email',
  SC52changePasswordComplete: 'The password change is complete',
}
